// Défis du vendredi et soutenances (R-PRG-04, R-TDB-05, R-PRG-05).
import { useMagasin, magasin } from '../donnees/magasin';
import { Html } from '../composants/Html';
import { semaineDeProgramme } from '@partage/programme';

export function Defis() {
  const { etat, bundles } = useMagasin();
  const bundle = bundles[etat.saison_courante];
  if (!bundle) return <p className="vide">Contenu de la saison indisponible.</p>;
  const semaineCourante = semaineDeProgramme(etat, bundle);
  return (
    <>
      <h2>Défis et soutenances</h2>
      <p className="doux">Le vendredi est facultatif : un défi non fait reste disponible, sans pénalité. Les soutenances de fin de saison sont obligatoires.</p>
      {bundle.semaines.map((s) => {
        const etatDefi = etat.progression.defis[s.defi.id]?.statut ?? 'propose';
        const etatSout = s.soutenance ? etat.progression.soutenances[s.soutenance.id]?.statut ?? 'a_faire' : undefined;
        const courante = s.numero === semaineCourante;
        return (
          <div className="carte" key={s.numero} style={courante ? { borderColor: 'var(--accent)' } : undefined}>
            <div className="ligne"><h3 style={{ margin: 0 }}>Semaine {s.numero} — {s.theme}</h3>{courante ? <span className="badge accent">en cours</span> : null}</div>
            <details open={courante}>
              <summary>Défi : {s.defi.titre} <span className={`badge ${etatDefi === 'fait' ? 'ok' : ''}`}>{etatDefi === 'fait' ? 'fait ✓' : etatDefi === 'passe' ? 'passé' : 'proposé'}</span></summary>
              <Html html={s.defi.enonce_html} />
              {s.defi.indices_html.length ? <details><summary>Indices</summary><ul>{s.defi.indices_html.map((h, i) => <li key={i} dangerouslySetInnerHTML={{ __html: h }} />)}</ul></details> : null}
              {s.defi.criteres.length ? <><strong>Critères :</strong><ul>{s.defi.criteres.map((c, i) => <li key={i}>{c}</li>)}</ul></> : null}
              <div className="ligne">
                <button className="principal petit" onClick={() => void magasin.emettre('defi_marque', { defi: s.defi.id, statut: 'fait' })} disabled={etatDefi === 'fait'}>Marquer fait</button>
                <button className="petit" onClick={() => void magasin.emettre('defi_marque', { defi: s.defi.id, statut: etatDefi === 'passe' ? 'propose' : 'passe' })}>{etatDefi === 'passe' ? 'Remettre en proposé' : 'Passer (sans pénalité)'}</button>
              </div>
            </details>
            {s.soutenance ? (
              <details style={{ marginTop: '0.6em' }}>
                <summary>Soutenance : {s.soutenance.titre} <span className={`badge ${etatSout === 'faite' ? 'ok' : s.soutenance.obligatoire ? 'attention' : ''}`}>{etatSout === 'faite' ? 'faite ✓' : s.soutenance.obligatoire ? 'obligatoire' : 'facultative'}</span></summary>
                <p><strong>Le mentor joue :</strong> {s.soutenance.role_mentor}</p>
                {s.soutenance.questions.length ? <><strong>Questions types :</strong><ul>{s.soutenance.questions.map((q, i) => <li key={i}>{q}</li>)}</ul></> : null}
                <p className="petit-texte doux">Lance <code>/soutenance</code> dans Claude Code, puis marque-la ici.</p>
                <button className="principal petit" onClick={() => void magasin.emettre('soutenance_marquee', { soutenance: s.soutenance!.id, statut: etatSout === 'faite' ? 'a_faire' : 'faite' })}>{etatSout === 'faite' ? 'Remettre à faire' : 'Marquer faite'}</button>
              </details>
            ) : null}
          </div>
        );
      })}
    </>
  );
}
